/**
 * Model for our individual domains.
 * 
 * @package Ninja Forms builder
 * @subpackage Fields
 * @copyright (c) 2015 WP Ninjas
 * @since 3.0
 */
define( 'models/app/domainModel',[
	'views/app/drawer/defaultSettingsTitle',
	'views/actions/drawer/settingsTitle',
	'views/advanced/drawer/calculationsTitle',
	'views/app/empty'
	],
	function(
		DefaultSettingsTitleView,
		ActionsSettingsTitleView,
		CalculationsTitleView,
		EmptyView
	) {
	var model = Backbone.Model.extend( {
		defaults: {
			dashicons: '',
			classes: '',
			active: false,
			url: '',
			hotkeys: false,
			disabled: false,

			getSettingsTitleView: function( data ) {
				if ( 'actions' == data.model.get( 'objectDomain' ) ) {
					return new ActionsSettingsTitleView( data );
				} else if ( 'calculations' == data.model.get( 'objectDomain' ) ) {
					return new CalculationsTitleView( data );
				} else {
					return new DefaultSettingsTitleView( data );
				}
			},

			getDefaultSettingsTitleView: function( data ) {
				return new DefaultSettingsTitleView( data );
			},

			getGutterLeftView: function( data ) {
				/*
				 * Return empty view
				 */
				return new EmptyView();
			},

			getGutterRightView: function( data ) {
				/* 
				 * Return empty view
				 */
				return new EmptyView();
			}
		}
	} );
	
	return model;
} );
